import { render, staticRenderFns } from "./fieldColor.vue?vue&type=template&id=563510e2&"
import script from "./fieldColor.vue?vue&type=script&lang=js&"
export * from "./fieldColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports